import { combineReducers } from '@reduxjs/toolkit';
import loginReducer from './loginInfoSlice';
import currentThemeReducer from './currentThemeSlice';
import sessionReducer from './session';
import chatsReducer from './chatsSlice';
import ticketReducer from '../slices/allTicketSlice';
import ticketStatusReducer from './ticketStatusSlice';
import aiResponseReducer from './aiResponseSlice';
import chatsFeedbackReducer from './chatsFeedbackSlice';
import chatHistoryReducer from './chatHistorySlice';
import transitionJourneyReducer from './transitionJourneySlice';
import chatProgressReducer from './chatProgressSlice';

const rootReducer = combineReducers({
  login: loginReducer,
  theme: currentThemeReducer,
  session: sessionReducer,
  chats: chatsReducer,
  ticketData: ticketReducer,
  ticketStatus: ticketStatusReducer,
  aiResponse: aiResponseReducer,
  chatsFeedback: chatsFeedbackReducer,
  chatHistory: chatHistoryReducer,
  transitionJourney: transitionJourneyReducer,
  chatProgress: chatProgressReducer,
});

export default rootReducer;